var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.getComponentName(),{tag:"component",attrs:{"items":_vm.sliderItems,"interval":3000}})}
var staticRenderFns = []

export { render, staticRenderFns }